import React from 'react';
import { useLocation } from 'react-router-dom';

// Shown on the home page after a rejected card scan. One neutral message for every cause (forged, retired,
// unknown, unresolved): it carries no city, card or reason.
export default function SignalLostNotice() {
  const location = useLocation();
  if (!location.state || location.state.signalLost !== true) return null;
  return (
    <div role="status" data-testid="signal-lost" style={{ textAlign: 'center', padding: '8px 16px', opacity: 0.7, fontSize: '0.85rem' }}>
      Signal lost or encrypted.
    </div>
  );
}
